// @flow

import React from 'react';
import styled from 'styled-components';

import { withJob } from 'react-jobs';
import { compose } from 'redux';
import { connect } from 'react-redux';

import type { Category as CategoryType } from '../../types/model';

import {
  requestAllCategories,
  requestCategory,
  selectors as FromCategories
} from '../../redux/modules/categories';

import { Loading } from '../StyledComponents';

import CategoryGroup from './CategoryGroup';

const Root = styled.div`
  flex: 1;
  flexBasis: 66.66%;

  position: relative;

  margin: 0 15px;
`

type Props = {
  categories: Array<CategoryType>,
  contentType: string,
  selectedId: ?number,
  requestAllCategories: Function,
  requestCategory: Function,
}

function CategoryNav({ categories, contentType, selectedId }: Props) {
  const direction = contentType === 'doctor' ? 'right' : 'left';

  return (
    <Root direction={direction}>
      {categories.length > 0 && (
        <CategoryGroup
          direction={direction}
          categories={categories}
          selectedId={selectedId}
          color="#3C3C3C"
        />
      )}
    </Root>
  )
}

function mapStateToProps(state, props) {
  const { contentType } = props

  return ({
    categories: FromCategories.getByContentType(state.categories, contentType),
  })
}

const mapActionsToProps = {
  requestAllCategories,
  requestCategory,
};

export default compose(
  connect(mapStateToProps, mapActionsToProps),
  withJob({
    work: (props: Props) => {
      const tasks = [];

      if (props.categories.length === 0) {
        tasks.push(props.requestAllCategories());
      }

      if (props.selectedId) {
        tasks.push(props.requestCategory(props.selectedId));
      }

      return Promise.all(tasks);
    },
    shouldWorkAgain: (prevProps, nextProps) => prevProps.selectedId !== nextProps.selectedId,
    LoadingComponent: Loading,
  })
)(CategoryNav);



// WEBPACK FOOTER //
// ./src/components/CategoryNav/CategoryNav.js